import React, { forwardRef } from 'react';
import MUIInputAdornment, {
  InputAdornmentProps as MUIInputAdornmentProps,
} from '@material-ui/core/InputAdornment';

interface InputAdornmentProps extends MUIInputAdornmentProps {}

const InputAdornment = forwardRef<HTMLDivElement, InputAdornmentProps>(
  (props, ref) => {
    return (
      <MUIInputAdornment {...props} ref={ref}>
        {props.children}
      </MUIInputAdornment>
    );
  }
);

InputAdornment.displayName = 'InputAdornment';

export default InputAdornment;
